<template>
    <Toast />
    <div class="p-grid">
        <div class="p-col-12">
            <div class="p-d-flex p-ai-center p-jc-between p-flex-column p-flex-lg-row p-mb-1">
                <h5>SMS Logs</h5>
            </div>
            <div class="card">
                <div class="p-d-flex p-ai-center p-flex-column p-flex-lg-row p-mb-1">
                    <div class="p-d-flex p-mr-3">
                        <Dropdown v-model="emp_name" :options="adminList" @change="getsmsLogs($event)"
                            optionLabel="label" appendTo="body" class="p-text-capitalize" placeholder="Select admin"
                            :style="{ minWidth: '200px' }" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <TabView v-if="userdatadisplayflag">
        <TabPanel header="SMS Log">
            <div class="card">
                <DataTable :value="smsLogs" :lazy="true" :paginator="true" :rows="30" :totalRecords="SMSCount"
                    :loading="loading" @page="onPageChange" class="p-datatable-users" data-key="ld1" :rowHover="true"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                    :style="{ 'overflow-wrap': 'break-word' }">
                    <template #empty> No data found. </template>
                    <template #loading> Loading data. Please wait... </template>
                    <Column header="Sr." headerStyle="width: 4%">
                        <template #body="{ index }">
                            <div>{{ genrateSrNo(index) }}</div>
                        </template>
                    </Column>
                    <Column field="datatime" header="Date" headerStyle="width: 10%" bodyStyle="width: 13%">
                        <template #body="{ data }">
                            <div>
                                <div>
                                    {{ format_timestamp(data.ld8) }}
                                </div>
                            </div>
                        </template>
                    </Column>
                    <Column field="mobile" header="Name" headerStyle="width: 15%" bodyStyle="width: 18%">
                        <template #body="{ data }">
                            <div class="mb-1 p-text-capitalize">{{ data.ld38 ? data.ld38 : "N/A" }}</div>
                            <div>{{ data.ld10 ? data.ld10 : "N/A" }}</div>
                        </template>
                    </Column>
                    <Column field="message" header="Message" headerStyle="width: 45%" bodyStyle="width: 42%">
                        <template #body="{ data }">
                            <div class="p-text-left">
                                <span v-if="!activate_read_key_arr.includes(data.ld1)">{{ data.ld11.slice(0, 135) }}
                                </span>
                                <a v-if="data.ld11.length >= 135 && !activate_read_key_arr.includes(data.ld1)"
                                    @click="activateReadMore(data.ld1)" class="showmorebody ps-1">read more</a>
                                <span v-if="activate_read_key_arr.includes(data.ld1)"
                                    v-html="replacebrake(data.ld11)"></span>
                                <span>
                                    <a v-if="data.ld11.length >= 135 && activate_read_key_arr.includes(data.ld1)"
                                        @click="deactivateReadMore(data.ld1)" class="showlessbody ps-1">read less</a>
                                </span>
                            </div>
                        </template>
                    </Column>
                    <Column field="smscount" header="SMS Count" headerStyle="width: 10%" bodyStyle="width: 12%"
                        class="justify-content-center">
                        <template #body="{ data }">
                            <div>
                                {{ data.ld24 ? data.ld24 : "0" }}
                            </div>
                        </template>
                    </Column>
                    <!-- <Column field="status" header="Charges" headerStyle="width: 16%" bodyStyle="width: 16%">
                        <template #body="{ data }">
                            <div>{{ data.ld31 && data.ld30 != 0 ? vueNumberFormat(data.ld31, {
                                prefix: '₹ ', decimal: '.', thousand: ',', precision: 2,
                                acceptNegative: true
                            }) : "To Be Billed" }}</div>
                        </template>
                    </Column> -->
                </DataTable>
                <Toast />
            </div>
        </TabPanel>
    </TabView>
</template>
<script>
import ApiService from '../../service/ApiService';
import moment from 'moment';

export default {
    data() {
        return {
            adminList: [],
            page_no: 0,
            SMSCount: 0,
            loading: false,
            smsLogs: [],
            emp_name: '',
            userdatadisplayflag: false,
            admin_id: '',
            admin_list_status: false,
            itemsPerPage: 30,
            searchnamebtnactive: false,
            hidesearchname: false,
            searchfullname: '',
            searchnameloader: false,
            activate_read_key_arr: [],


        };
    },
    ApiService: null,
    created() {
        this.ApiService = new ApiService();
    },
    mounted() {
        this.storage_path = JSON.parse(localStorage.masterBucketName);
        if (this.$store.state.adminId != null) {
            this.admin_id = this.$store.state.adminId;
            let adminId = this.$store.state.adminId;
            this.ApiService.getAdminListOnly().then((data) => {
                if (data.status == 200) {
                    this.adminList = data.data.records;
                    let emp_name_id = data.data.records.filter(function (item) {
                        return item.value == adminId;
                    });
                    if (emp_name_id.length > 0) {
                        this.emp_name = emp_name_id[0];
                    }
                    this.getsmsLogs();
                } else {
                    this.adminList = null;
                }
            });
        } else {
            this.getAdminListOnly();
        }
    },

    methods: {
        getAdminListOnly(e) {
            this.ApiService.getAdminListOnly(e).then((data) => {
                if (data.status == 200) {
                    this.adminList = data.data.records;
                    if (data.data.records.length == 1) {
                        this.getsmsLogs({ value: data.data.records[0] });
                        this.emp_name = data.data.records[0];
                    }
                } else {
                    this.adminList = null;
                }
            });
        },
        getsmsLogs(e) {
            this.userdatadisplayflag = true;
            this.loading = true;
            if (e) {
                this.admin_id = e.value.value;
            }
            this.activate_read_key_arr=[];
            this.ApiService.getsmsLogs({ clientId: this.admin_id, page_no: this.page_no, itemsPerPage: this.itemsPerPage }).then((data) => {
                if (data.success === true) {
                    this.smsLogs = data.data;
                    this.SMSCount = data.count;
                    this.loading = false;
                    this.admin_list_status = true;

                    this.searchnameloader = false;
                    // this.searchmobloader = false;
                    this.hidesearchname = false;
                    this.hidesearchmob = false;
                }
            });
        },
        activateReadMore(e) {
            this.activate_read_key_arr.push(e);
        },

        deactivateReadMore(e) {
            var index = this.activate_read_key_arr.indexOf(e);
            if (index !== -1) {
                this.activate_read_key_arr.splice(index, 1);
            }
        },
        onPageChange(e) {
            this.loading = true;
            if (this.admin_list_status) {
                this.page_no = e.page;
                this.getsmsLogs();
            }
        },
        searchFnameVoter(searchfullname) {
            this.hidesearchname = true;
            this.searchnameloader = true;
            this.lr14 = searchfullname;
            this.getsmsLogs({
                page_no: this.page_no,
                lr14: this.lr14,
            });
            this.searchnamebtnactive = true;
        },
        searchNameVoterStop() {
            this.searchnamebtnactive = false;
            this.searchfullname = "";
            this.getsmsLogs({
                page_no: this.page_no,
            });
            this.searchnameloader = false;
        },
        format_timestamp(value) {
            if (value) {
                var localTime = new Date(value * 1000).toUTCString();
                return moment(localTime).format("DD/MM/YYYY @ hh:mm A");
            } else {
                return 'N/A';
            }
        },

        replacebrake(html) {
            const doc = html;
            return doc.replace(/(\r)*\n/g, '<br>');
        },
        decodeHtml(html) {
            return JSON.parse('"' + html + '"');
        },
    },
};
</script>
<style scoped lang="scss">
.custom-form-group {
    display: flex;
    align-items: center;
}
</style>
